class Covidence.Country extends Backbone.Model

class Covidence.Countries extends Backbone.Collection
  model: Covidence.Country
